export default "__VITE_ASSET__b5pKlPyZ__"